import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const todoColumnService = {
  // Get all columns
  getColumns: async () => {
    const response = await axios.get(
      `${API_URL}/api/${API_VERSION}/todo-columns`,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Create a new column
  createColumn: async (columnData) => {
    const response = await axios.post(
      `${API_URL}/api/${API_VERSION}/todo-columns`,
      columnData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Update a column
  updateColumn: async (id, columnData) => {
    const response = await axios.put(
      `${API_URL}/api/${API_VERSION}/todo-columns/${id}`,
      columnData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Delete a column
  deleteColumn: async (id) => {
    const response = await axios.delete(
      `${API_URL}/api/${API_VERSION}/todo-columns/${id}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Reorder columns
  reorderColumns: async (columns) => {
    const response = await axios.post(
      `${API_URL}/api/${API_VERSION}/todo-columns/reorder`,
      { columns },
      { headers: getAuthHeader() }
    );
    return response.data;
  }
};

export default todoColumnService;

// ---
